/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    FETCHING_CLIENT_EMBEDS_DATA,
    RECEIVE_CLIENT_EMBEDS_DATA,
    REMOVE_EMBED_DATA,
    ARCHIVING,
    TOGGLE_ARCHIVE,
    RECEIVE_LABELS,
    ADD_LABEL,
    DELETE_LABEL,
    SET_EMBED_CARD_LABELS,
    FETCHING_EMBED_NAMES,
    RECEIVE_EMBED_NAMES
} from 'state/actions/embedsState/embeds_status';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';



/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBEDS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    isDataReceived: false,
    fetchingEmbeds: false,
    clientEmbeds: [],
    currentPage: 1,
    totalEmbeds: 0,
    totalPages: 0,
    archiving: null,
    toggledArchive: [],
    labels: {},
    labelsReceived: false,
    embedNames: [],
    fetchingEmbedNames: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const embedsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case FETCHING_CLIENT_EMBEDS_DATA:
            if(action.status === true){
                newState.clientEmbeds = defaultState.clientEmbeds;
            }
            newState.fetchingEmbeds = action.status;
            return newState;
        case RECEIVE_CLIENT_EMBEDS_DATA:
            newState.isDataReceived = true;
            newState.clientEmbeds = action.data.embedDetails;
            newState.currentPage = action.data.currentPage;
            newState.totalEmbeds = action.data.totalEmbeds;
            newState.totalRows = action.data.totalRows;
            newState.totalPages = action.data.totalPages;
            newState.toggledArchive = defaultState.toggledArchive;
            return newState;
        case REMOVE_EMBED_DATA:
            newState.clientEmbeds = newState.clientEmbeds.filter(embed => embed.embedUUID !== action.embedUUID);
            return newState;
        case ARCHIVING:
            newState.archiving = action.embedUUID;
            return newState;
        case TOGGLE_ARCHIVE:
            let archivedIndex = newState.toggledArchive.indexOf(action.embedUUID);
            archivedIndex >= 0 ?newState.toggledArchive.splice(archivedIndex, 1) : newState.toggledArchive.push(action.embedUUID);
            return newState;
        case CLEAR_ALL_STATES:
            return defaultState;
        case RECEIVE_LABELS:
            newState.labels = action.labels;
            newState.labelsReceived = true;
            return newState;
        case ADD_LABEL:
            newState.labels = { ...newState.labels, ...action.label };
            return newState;
        case DELETE_LABEL:
            delete newState.labels[action.labelUUID];
            return newState;
        case SET_EMBED_CARD_LABELS:
            newState.clientEmbeds = newState.clientEmbeds.map(embed => {
                if(embed.embedUUID === action.embedUUID) { embed.labelUUIDs = action.labelUUIDs }
                return embed;
            });
            return newState;
        case FETCHING_EMBED_NAMES:
            newState.fetchingEmbedNames = action.status;
            return newState;
        case RECEIVE_EMBED_NAMES:
            if(action.names){
                newState.embedNames = Object.keys(action.names).map(embedUUID => action.names[embedUUID]);
            }
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedsStatus;
